// Global packages and components
import { clsx } from 'clsx'
import { useState } from 'react'
import { NavLink, MegaNavInner } from '~/components'

// Types
import type { SanityNavItem } from '~/types'

interface Props {
  items: SanityNavItem[]
}

const HeaderNav = ({ items }: Props) => {
  const [megaNavActive, setMegaNavActive] = useState<number | null>(null)

  return (
    <div
      className={clsx(
        'relative hidden items-center justify-between rounded-t-2xl bg-neutral-100 px-6 lg:flex',
        {
          'rounded-b-2xl': !megaNavActive,
        }
      )}
    >
      <ul className="-mx-2 flex">
        {items.map((grandParent, gi) => (
          <li
            className="group/grandparent px-1 xl:px-2"
            key={'grandparent' + gi}
            onMouseEnter={() => setMegaNavActive(gi + 1)}
            onMouseLeave={() => setMegaNavActive(null)}
          >
            <NavLink
              {...grandParent}
              className={clsx(
                'inline-block border-b-2 border-transparent px-3 py-6',
                {
                  'border-teal-green text-teal-green':
                    !grandParent.titleHighlight && megaNavActive == gi + 1,
                  'border-red-600':
                    grandParent.titleHighlight && megaNavActive == gi + 1,
                }
              )}
            />
            {grandParent?.childItems && (
              <div
                className={clsx(
                  'absolute left-0 top-full z-10 w-full rounded-b-lg bg-white shadow-md',
                  {
                    block: megaNavActive == gi + 1,
                    hidden: megaNavActive !== gi + 1,
                  }
                )}
              >
                <MegaNavInner
                  navItems={grandParent.childItems}
                  featuredItems={grandParent?.featuredItems}
                  setMegaNavActive={setMegaNavActive}
                />
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default HeaderNav
